import React from 'react'

import quickAdd_createGroup from "../../../../../app/quick-add/sections/group/helpers/create-group"
import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"

type Props = {
    level?      : number
    parentId?   : ID

    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddGroup"
const debug = false

export default function NavigationMenuItemAddGroup(props: Props) {

    const projectIcon = 'group'

    const onCommit = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        await quickAdd_createGroup({
            parentProject   : props.parentId,
            name            : value,
            color           : gd.session.projects.get(props.parentId)?.color,
        })
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}